<template>
  <div class="fluid page_content db_lyt_v22 adviosr_learner_home" aria-label="Advisee Home Page">
    <div class="advisee_sec_crd">
      <div class="row page-heading">
        <div class="col-5 module_heading" role="heading" aria-level="1">
          <span class="module_icon" :class="'ic-' + advisee.userRole"></span>
          <span class="module_title"> {{advisee.userName}} </span>
        </div>
      </div>
      <div class="row">
        <b-col cols="12" class="db_pg_content">
          <b-row class="dashboard-row">
            <b-col cols="4" class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
              <!-- Profile -->
              <div class="card ace_sec crd_program">
                <div class="card-header" v-if="isLearnerProfileEnabled">
                  <div
                    class="label ace_sec_hd"
                    aria-level="1"
                    :aria-label="$tf('profile')"
                    role="heading">
                     {{ $tf('profile') }}
                  </div>
                  <div class="float-right lnk_container report_link">
                    <a
                      href="javascript://"
                      class="ace_sec"
                      @click="navigateToAdviseeProfile">
                        {{ $tf('more') }}
                    </a>
                  </div>
                </div>
                <div class="card-body">
                  <template v-if="isShowProgramName">
                    <div class="row">
                      <div class="col-12 block_row" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams.length > 0 && advisee.adviseeSharedStreams[0].majorTitle && advisee.adviseeSharedStreams[0].majorTitle.length > 0">
                        <span class="block_label" tabindex="0">{{majorLabel}}: </span>
                        <span class="block_val">{{advisee.adviseeSharedStreams[0].majorTitle}}</span>
                      </div>
                      <div class="col-12 block_row" v-else>
                        <span class="block_label" tabindex="0">{{majorLabel}}: </span>
                        <span class="block_val">
                          {{ $tf('undecided') }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <template v-if="isShowCareerInterest">
                    <div class="row">
                      <div class="col-12 block_row" v-if="advisee.careerGoal">
                        <span class="block_label" tabindex="0">{{careerLabel}}: </span>
                        <span class="block_val">{{advisee.careerGoal}}</span>
                      </div>
                      <div class="col-12 block_row" v-else>
                        <span class="block_label" tabindex="0">{{careerLabel}}: </span>
                        <span class="block_val">
                          {{ $tf('undecided') }}
                        </span>
                      </div>
                    </div>
                  </template>
                  <div class="row">
                    <div class="col-12 lnk_container report_link" v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams[0].uuid">
                      <b-link v-if="advisee.adviseeSharedStreams && advisee.adviseeSharedStreams[0].uuid" :to="{ name: 'streamReport', params: { uuid: advisee.adviseeSharedStreams[0].uuid, userId: advisee.userId }}">
                        <span class="icon icon-activity"></span>
                        <span class="lnk_txt"> {{advisee.userName}}'s activity report</span>
                      </b-link>
                    </div>
                  </div>
                  <template v-if="adviseeTags.length > 0">
                    <div class="row">
                      <div class="col-12 block_row tags_container_row">
                        <div class="ic-tag"></div>
                        <div class="applied_tags">
                          <span class="tag" v-for="tag in adviseeTags">
                            <span class="tag_name">
                              {{ tag }}
                            </span>
                          </span>
                        </div>
                        <template v-if="adviseeTags.length > 3">
                          <div class="show_more_tags active">
                            <b-dropdown variant="link" no-caret class="all_tags_list">
                              <template slot="button-content">
                                <span class="btn_more">...</span>
                              </template>
                              <div class="links_container">
                                <div class="links">
                                  <span class="tag" v-for="tag in adviseeTags">
                                    <span class="tag_name">{{tag}}</span>
                                  </span>
                                </div>
                              </div>
                            </b-dropdown>
                          </div>
                        </template>

                      </div>
                    </div>
                  </template>

                </div>
              </div>
              <!-- Profile Ends -->

              <!-- Calendar -->
              <div class="card ace_sec crd_cal" v-if="isCalendarEnabled">
                <div class="card-body">
                  <div class="icon ic22-dateRange">
                  </div>
                  <div class="row cal_detail">
                    <template v-if="calendarEvents.length > 0" >
                      <div class="col-12 block_row">
                        <span class="label"> {{ $tf('when') }}: </span>
                        {{ calendarEvents[0].formattedStartDateTime }}
                      </div>
                      <div class="col-12 block_row">
                        <span class="label"> {{ $tf('where') }}: </span>
                        {{ calendarEvents[0].location }}
                      </div>
                      <div class="col-12 block_row">
                        <span class="label"> {{ $tf('what') }}: </span>
                        {{calendarEvents[0].title}}
                      </div>
                      <div class="col-12 lnk_container">
                        <b-link :to="{name: 'adviseeCalendarEventList', params: {userUuid: uuid}}">
                          {{ $tf('more') }}
                        </b-link>
                      </div>
                    </template>
                    <template v-if="calendarEvents.length == 0" >
                      <div class="col-12 block_row text-center">
                        No upcoming events
                      </div>
                      <div class="col-12 lnk_container">
                        <b-link :to="{name: 'adviseeCalendarEventList', params: {userUuid: uuid}}">
                          past events
                        </b-link>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <!-- Calendar Ends -->

              <!-- Academic Progress -->
              <template v-if="isProgramProgressEnabled && enrolledPrograms.length > 0">
              <div class="card ace_sec crd_progress">
                <div class="card-header">
                  <span class="ic ico-meter float-left text-center mr-1 mt-1"></span>
                  <span
                    class="label ace_sec_hd"
                    role="heading"
                    aria-level="1"
                    :aria-label="$tf('academicProgress')"
                    style="width: 90%;">
                    {{ $tf('academicProgress') }}
                  </span>
                </div>

                <div class="card-body">
                  <div class="enrolled_program_row" v-for="prg in enrolledPrograms">
                    <div class="title">
                      <a
                        href="javascript://"
                        @click="showSelectedProgramProgress(prg)"
                        class="ace_sec_txt"
                        tabindex="0"
                        :aria-label="prg.programTitle">
                          {{prg.programTitle}}
                      </a>
                    </div>
                    <div class="progress-row" v-if="showCourseProgress" @click="showSelectedProgramProgress(prg)">
                      <div class="progress-bar-label ace_sec_txt" :aria-label="prg.inprogressCourses + ' of ' + prg.totalCourses + ' courses'"></div>
                      <b-progress :max="prg.totalCourses">
                        <b-progress-bar :value="prg.completedCourses" :title="showBarTitle(prg.completedCourses, 'completed')" :aria-label="showBarTitle(prg.completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.hover> {{prg.completedCourses}} </b-progress-bar>
                        <b-progress-bar :value="prg.inprogressCourses" :title="showBarTitle(prg.inprogressCourses, 'in-progress')" :aria-label="showBarTitle(prg.inprogressCourses, 'in progress')" class="prog_bar__in_progress" v-b-tooltip.hover> {{prg.inprogressCourses}} </b-progress-bar>
                        <b-progress-bar :value="prg.notStartedCourses" :title="showBarTitle(prg.notStartedCourses, 'not started')" :aria-label="showBarTitle(prg.notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.hover> {{prg.notStartedCourses}} </b-progress-bar>
                      </b-progress>
                      <!--
                      <div class="float-right">
                        <a href="javascript://" class="ace_sec_txt" tabindex="0" aria-label="more" @click="showSelectedProgramProgress(prg)">more</a>
                      </div>
                      -->
                    </div>
                    <div class="progress-row" v-else>
                      <div class="progress-bar-label ace_sec_txt" :aria-label="prg.childrenCompleteCount + ' of ' + prg.childrenCount + ' competencies'">{{prg.childrenCompleteCount}} of {{prg.childrenCount}} competencies</div>
                      <b-progress :max="prg.childrenCount">
                        <b-progress-bar :value="prg.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                      </b-progress>
                      <div class="float-right">
                        <a href="javascript://" class="ace_sec_txt" tabindex="0" aria-label="more" @click="showSelectedProgramProgress(prg)">
                          {{ $tf('more') }}
                        </a>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
              </template>
              <!-- Academic Progress Ends -->
            </b-col>

            <b-col cols="4" class="col-xl-4 col-lg-4 col-md-12 col-sm-12 sec_notes">
              <advisee-note :advisee="advisee" v-if="isDataLoaded" ref="adviseeNote"></advisee-note>
            </b-col>

            <b-col cols="4" class="col-xl-4 col-lg-4 col-md-12 col-sm-12 sec_channel">
              <advisee-channel :advisee="advisee" v-if="isDataLoaded" ref="adviseeChannel"></advisee-channel>
            </b-col>
          </b-row>
        </b-col>
      </div>
      <template v-if="isDataLoaded">
        <note-action-menu ref="advisorNoteActionMenu" :action="'view'" :user-ids="[{userUuid: advisee.userId}]" :hide-note-icon="true" :note-type="selectedNoteType"></note-action-menu>

        <channel-action-menu ref="adviseeChannelActionMenu" :action="'sendGroupMessage'" :user-ids="[{userUuid: advisee.userId}]" :hide-channel-icon="true"></channel-action-menu>
      </template>
    </div>

    <div>
      <b-modal id="academic-progress-popup" class="full_screen_modal" ref="academicProgressModal" :header-bg-variant="'academic-progress-popup-header'" size="" hide-footer no-close-on-backdrop no-close-on-esc v-if="modalHeaderLabel">
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt text-center">
            <span>{{modalHeaderLabel}}</span>
          </div>
          <div>
            <button class="btn_close" aria-label="close" @click="closeAcademicProgressModal">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <template v-if="selectedProgram">
          <div class="pg_content">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
              <div class="row pg_sec">
                <div class="col-4 hd ace_sec_hd">
                  <div class="score_sec">
                    <div class="label">
                      {{ $tf('score') }}
                    </div>
                    <div class="progress_block">
                      <span class="state" :class="statusClass(selectedProgram)" style="height: 32px; width: 70px;">
                        <span v-if="selectedProgram.isScoreNotAvailable" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
                        <span v-else class="progress_val ace_sec_txt" style="font-size: 15px;">{{selectedProgram.score}}%</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="progress-row" v-if="!showCourseProgress">
                    <div class="progress-bar-label" :title="selectedProgram.childrenCompleteCount + ' of ' + selectedProgram.childrenCount + ' competencies'" v-b-tooltip.hover>{{selectedProgram.childrenCompleteCount}} of {{selectedProgram.childrenCount}} competencies</div>
                    <b-progress :max="selectedProgram.childrenCount">
                      <b-progress-bar :value="selectedProgram.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                    </b-progress>
                  </div>
                  <div class="progress-row" v-else>
                      <div class="progress-bar-label ace_sec_txt" :aria-label="selectedProgram.inprogressCourses + ' of ' + selectedProgram.totalCourses + ' courses'"></div>
                      <b-progress :max="selectedProgram.totalCourses">
                        <b-progress-bar :value="selectedProgram.completedCourses" :title="showBarTitle(selectedProgram.completedCourses, 'completed')" :aria-label="showBarTitle(selectedProgram.completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.hover> {{selectedProgram.completedCourses}} </b-progress-bar>
                        <b-progress-bar :value="selectedProgram.inprogressCourses" :title="showBarTitle(selectedProgram.inprogressCourses, 'in-progress')" :aria-label="showBarTitle(selectedProgram.inprogressCourses, 'in progress')" class="prog_bar__in_progress" v-b-tooltip.hover> {{selectedProgram.inprogressCourses}} </b-progress-bar>
                        <b-progress-bar :value="selectedProgram.notStartedCourses" :title="showBarTitle(selectedProgram.notStartedCourses, 'not started')" :aria-label="showBarTitle(selectedProgram.notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.hover> {{selectedProgram.notStartedCourses}} </b-progress-bar>
                      </b-progress>
                    </div>
                </div>

                <div class="col-4 btn_container">
                  <b-button class="float-right" @click="openReprocessModal(selectedProgram,advisee)" style="margin-top: 1px; padding: 5px 18px; margin-left: 20px;" v-if="isReporcessEnrollmentEnabled">
                    <span>
                      {{ $tf('reProcessEnrollment', 're-process enrollment') }}
                    </span>
                  </b-button>

                  <b-button class="float-right" v-if="customAdvisorAllowUnenroll()" @click="openLearnerUnenrollModal(selectedProgram,advisee)" style="margin-top: 1px; padding: 5px 18px; margin-left: auto; ">
                    <span>
                      {{ $tf('unenroll', 'unenroll') }}
                    </span>
                  </b-button>
                </div>

                <learner-courses :parent="selectedProgram" :parentTitle="selectedProgram.programTitle" :pObject="this" :courses="selectedProgram.courses" :learnerUserId="uuid">
                </learner-courses>

                <template v-if="selectedProgram.courses.length==0">
                <div class="col-12 sec_content self_reported_courses">
                  <b-jumbotron>
                    <h4 class="text-center ace_sec_txt">
                      {{ $tf('academicProgressAvailabilityMsg') }}
                    </h4>
                  </b-jumbotron>
                </div>
                </template>

              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row">
            <div class="col-12">
              <div class="text-center" style="background: #969695; height: 60px;">
                <div class="header-text">All Programs</div>
              </div>
            </div>
          </div>
          <div class="row" v-for="data in enrolledPrograms">
            <div class="col-12">
              <div class="row mt-3">
                <div class="col-8 ml-5" style="cursor: pointer;" @click="showSelectedProgramProgress(data)">
                  <template v-if="data.programThumbnail">
                    <div class="col-2 float-left">
                      <img :src="data.programThumbnail" style="height: 80px; width: 80px;">
                    </div>
                  </template>
                  <template v-else>
                    <div class="ic_container">
                      <div class="ic icon_program"></div>
                    </div>
                  </template>
                  <div class="w-75 mt-4">
                    <div class="ace_sec">{{data.programTitle}}</div>
                    <div class="ace_sec"><small>{{data.childrenCount}} Competencies</small></div>
                  </div>
                </div>
                <div class="col-3 my-4">

                  <div class="progress-row">
                    <div class="progress-bar-label ace_sec_txt" :aria-label="data.childrenCompleteCount + ' of ' + data.childrenCount + ' competencies'">{{data.childrenCompleteCount}} of {{data.childrenCount}} competencies</div>
                    <b-progress :max="data.childrenCount" height="32px" style="background: #dd9623;">
                      <b-progress-bar :value="data.childrenCompleteCount"  style="background: #0a7714;"></b-progress-bar>
                    </b-progress>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

      </b-modal>
    </div>

    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseReleaseModal" class="description_modal" size="md" id="course-report-popup" hide-footer >
        <div slot="modal-header" class="header-section">
          <div class="ic_container">
            <span class="ic ic22-lock" v-if="!releaseStatus"></span>
            <span class="ic ic22-unlock" v-else></span>
          </div>
          <div class="head_txt align-middle">{{releaseModalHeaderLabel}}</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseReleaseModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row">
          <div class="col-12 txt_row">
            <div v-html="selectedCourseForReleaseTitle"></div>
          </div>
          <div class="col-12 txt_row">
            <div v-html="releaseLogicDetail"></div>
          </div>
          <div class="col-12 txt_row" >
            <div v-if="!releaseStatus">
            </div>
            <div v-else>
              Unlocked By <strong><i>{{releaseStatusUpdatedBy}}  {{millisToDate(releaseStatusUpdatedTime)}} </i></strong>
            </div>
          </div>
          <div class="col-12 txt_row btn_container">
            <b-button class="btn" @click="closeLearnerCourseReleaseModal">ok</b-button>
            <template v-if="!releaseStatus">
              <b-button class="btn" @click="manualRelease">unlock course</b-button>
            </template>
            <template v-if="releaseStatus">
              <b-button class="btn" @click="manualLock">lock course</b-button>
            </template>
          </div>
        </div>
      </b-modal>
    </div>

<!-- Unenroll Model -->
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerUnenrollModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">Unenroll User</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerUnenrollModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div v-if="selectedProgram">
            Unenroll {{advisee.userName}} from {{selectedProgram.programTitle}}
          </div>
        </div>
        <div class="row txt_row">
          <div>
            <div>Are you sure?</div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeLearnerUnenrollModal">cancel</b-button>
            <b-button @click="unenrollUserFromProgram">unenroll</b-button>
          </div>
        </div>
      </b-modal>
    </div>

<!-- Unenroll Model End -->
<!-- Reprocess Enrollment Model -->
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="reprocessModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt">Re-Process Enrollment for User</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeReprocessModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div v-if="selectedProgram">
            Re-process enrollment for {{advisee.userName}} for {{selectedProgram.programTitle}}
          </div>
        </div>
        <div class="row txt_row">
          <div>
            <div>This process will remove enrollment for user and re-enroll to newly mapped course sections.</div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeReprocessModal">cancel</b-button>
            <b-button @click="rePrecessProgramEnroolemtForUser">re-process</b-button>
          </div>
        </div>
      </b-modal>
    </div>

<!-- Reprocess Enrollment Model End -->

    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseWaiveModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">{{waiveModalHeaderLabel}}</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseWaiveModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div class="col-3 fld_label">
            Course
          </div>
          <div class="col-9 fld_val">
            <div v-html="selectedCourseForWaiveTitle"></div>
          </div>
        </div>

        <div class="row txt_row mt-3" v-if="waiveStatus">
          <div class="col-3 fld_label">
            Reason
          </div>
          <div class="col-9 fld_val">
              <span v-html="waiveLogicDetail"></span> <br/>
              Waived By <strong><i>{{waiveStatusUpdatedBy}}  {{millisToDate(waiveStatusUpdatedTime)}} </i></strong>
          </div>
        </div>

        <template v-if="!waiveStatus">
          <div class="row txt_row mt-3">
            <div class="col-3 fld_label">
              Reason
            </div>
            <div class="col-9 fld_input">
              <textarea  placeholder="type reason for waiving" aria-label="reason for waiving" v-model="waiveLogicDetail" rows=3 />
            </div>
          </div>

          <div class="row txt_row mt-3">
            <div class="col-3 fld_label">
              % Score
            </div>
            <div class="col-9 fld_input">
              <input aria-label="score" v-model="waiveScore" size="4"> <span class="exp_info">example: 85</span>
            </div>
          </div>
        </template>

        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeLearnerCourseWaiveModal">
              {{ $tf('cancel') }}
            </b-button>
            <b-button @click="manualWaive" v-if="!waiveStatus">
              {{ $tf('waiveCourse', 'Waive Course') }}
            </b-button>
            <b-button @click="manualUnwaive" v-if="waiveStatus">Unwaive course</b-button>

          </div>
        </div>
      </b-modal>
    </div>

    <div class="modal_popup_container course_unlock_modal modify_score_modal">
      <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
        <div slot="modal-header" class="header-section">
          <div class="head_txt" style="margin-top: 1px;">Edit Overall Score and Progress</div>
          <div class="btn_container">
            <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
              <span class="ic-close"></span>
            </button>
          </div>
        </div>

        <div class="row txt_row">
          <div class="col-6">
            Course:
          </div>
          <div class="col-6 fld_val">
            <div v-html="selectedCourseForOverrideTitle"></div>
          </div>
        </div>
        <div class="row txt_row">
          <div class="col-6">
            User:
          </div>
          <div class="col-6 fld_val">
            <div v-if="selectedCourseSummaryForOverride">
            {{selectedCourseSummaryForOverride.firstName}} {{selectedCourseSummaryForOverride.lastName}}
            </div>
          </div>
        </div>
          <div class="row txt_row mt-3">
            <div class="col-6 ">
              Actual Overall Score:
            </div>
            <div class="col-6 fld_input" v-if="selectedCourseSummaryForOverride">
              <span v-if="selectedCourseSummaryForOverride.overriddenTime" class="">
                {{ selectedCourseSummaryForOverride.prePerformance?selectedCourseSummaryForOverride.prePerformance:0.00 }}%
              </span>
              <span v-else class="exp_info">{{selectedCourseSummaryForOverride.performance}}%</span>
            </div>
          </div>

          <div class="row txt_row mt-3">
            <div class="col-6 ">
              Edited Overall Score:
            </div>
            <div class="col-6 fld_input">
              <input aria-label="score" v-model="overrideScore" size="4"> %
              <span class="exp_info">example: 85%</span>
            </div>
          </div>

          <div class="row txt_row mt-3">
            <div class="col-6 ">
              Actual Overall Progress:
            </div>
            <div class="col-6 fld_input" v-if="selectedCourseSummaryForOverride && selectedCourseSummaryForOverride.overriddenTime">
            <div class="progress-bar-label">
              {{selectedCourseSummaryForOverride.preChildrenCompleteCount}} of {{selectedCourseSummaryForOverride.childrenCount}}
            </div>
            <b-progress :max="selectedCourseSummaryForOverride.childrenCount">
              <b-progress-bar :value="selectedCourseSummaryForOverride.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
            </div>
            <div class="col-6 fld_input" v-else-if="selectedCourseSummaryForOverride">
            <div class="progress-bar-label">
              {{selectedCourseSummaryForOverride.childrenCompleteCount}} of {{selectedCourseSummaryForOverride.childrenCount}}
            </div>
            <b-progress :max="selectedCourseSummaryForOverride.childrenCount">
              <b-progress-bar :value="selectedCourseSummaryForOverride.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
            </b-progress>
            </div>
          </div>
          <div class="row txt_row mt-3" v-if="selectedCourseSummaryForOverride && selectedCourseSummaryForOverride.overriddenTime>0">
            <div class="col-6">
              Edited Overall Progress:
            </div>
            <div class="col-6 fld_input">
              <div class="progress-bar-label">
                {{selectedCourseSummaryForOverride.childrenCompleteCount}} of {{selectedCourseSummaryForOverride.childrenCount}}
              </div>
              <b-progress :max="selectedCourseSummaryForOverride.childrenCount">
                <b-progress-bar :value="selectedCourseSummaryForOverride.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
              </b-progress>
            </div>
          </div>
        <div class="row mt-4">
          <div class="col-12 btn_container" style="text-align: right;">
            <b-button @click="closeLearnerCourseOverrideModal">
              {{ $tf('cancel') }}
            </b-button>
            <b-button @click="manualOverride">
              {{ $tf('save', 'save') }}
            </b-button>

          </div>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="course-report-popup" class="full_screen_modal" ref="learnerCourseReportModal" :header-bg-variant="'academic-progress-popup-header'" size="" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="popup_head_txt head_txt text-center" style="width: 80%;">
            <span style="padding-left: 18rem;">{{reportModalHeaderLabel}}</span>
          </div>
          <div class="float-right">
            <button class="btn_close" aria-label="close" @click="closeLearnerCourseReportModal">
              <span class="ic-close"></span>
            </button>
          </div>
          <div class="float-right mr-5" v-if="isInstructorAdvisor">
            <span style="cursor: pointer; color: #157099;" @click="navigateToClassCourseReport"><strong>Go to course report</strong></span>
          </div>
        </div>

        <student-my-report v-if="selectedCourseForReporting" :uuid="selectedCourseForReporting.originUuid" :entityId="selectedCourseForReporting.originUuid" :userId="uuid"></student-my-report>

      </b-modal>
    </div>

  </div>
</template>

<script>
  import _ from 'lodash'
  import { DateTime } from 'luxon'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import AdviseeNote from './AdviseeNote'
  import AdviseeChannel from './AdviseeChannel'
  import NoteActionMenu from './NoteActionMenu'
  import ChannelActionMenu from './ChannelActionMenu'
  import AdviseeProgramCourseScoreAndProgress from './AdviseeProgramCourseScoreAndProgress'
  import StudentMyReport from '../../course/components/StudentMyReport'
  import AdvisorProgramCourseStructure from './AdvisorProgramCourseStructure'
  import LearnerCourses from './LearnerCourses'

  export default {
    name: 'learner-dashboard',
    props: ['uuid', 'isInstructorAdvisor'],
    components: {
      AdviseeNote,
      AdviseeChannel,
      NoteActionMenu,
      ChannelActionMenu,
      StudentMyReport,
      AdviseeProgramCourseScoreAndProgress,
      AdvisorProgramCourseStructure,
      LearnerCourses
    },
    data: () => {
      return {
        testingEnable : true,
        advisee: {},
        adviseeTags: [],
        calendarEvents: [],
        isDataLoaded: false,
        selectedNoteType: 'Shared',
        enrolledPrograms: [],
        selectedProgram: null,
        modalHeaderLabel: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        reportModalHeaderLabel: '',
        selectedCourseForReporting: null,
        selectedCourseForRelease: null,
        releaseModalHeaderLabel:'',
        releaseLogicDetail : '',
        releaseStatus : true,
        releaseStatusUpdatedBy : 'System',
        releaseStatusUpdatedTime: undefined,
        selectedCourseForReleaseTitle : '',
        selectedCourseForWaive: null,
        waiveModalHeaderLabel:'',
        waiveLogicDetail : '',
        waiveScore : '',
        waiveStatus : false,
        waiveStatusUpdatedBy : 'System',
        waiveStatusUpdatedTime: undefined,
        selectedCourseForWaiveTitle : '',
        selectedCourseForOverrideTitle : '',
        selectedCourseSummaryForOverride : null,
        selectedCourseForOverride : null,
        overrideScore : '',
        overrideStatusUpdatedBy : 'System',
        overrideStatusUpdatedTime: undefined

      }
    },
    async beforeMount () {
      this.enrolledPrograms = []
      let enrollmentData = await this.loadLearnerEnrollmentData(this.uuid)
      _.forEach(_.sortBy(enrollmentData, 'uuid'), (data) => {
        this.resetData(data)
        this.populateStreamStructure(data)
      })
    },
    mounted () {
      this.loadLearnDashboard()
    },
    methods: {
      ...mapActions([
        'loadAdviseeDetail',
        'loadPersonTags',
        'loadStreamWithStructure',
        'loadLearnerEnrollmentData',
        'loadFutureCalendarEventsForParticipant',
        'loadMicroCompetencyProgressForSelectedUser',
        'releaseCourse',
        'waiveCourse',
        'unenrollFromProgram',
        'loadStreamWithStructureSummary',
        'reProcessProgramEnrollment',
        'overrideCourseScore'

      ]),
      resetData (data) {
        data.score = 0
        data.courses = []
        data.performance = 0
        data.childrenCount = 0
        data.childrenCompleteCount = 0
        data.progressSummaryCount = 0
        data.isScoreNotAvailable = true
        data.totalCourses = 0
        data.completedCourses = 0
        data.inprogressCourses = 0
        data.notStartedCourses = 0

      },
      async reloadData(program){
        this.enrolledPrograms = []
        let enrollmentData = await this.loadLearnerEnrollmentData(this.uuid)
        _.forEach(_.sortBy(enrollmentData, 'uuid'), (data) => {
          this.resetData(data)
          this.populateStreamStructure(data)
        })
        for(let i=0;i<this.enrolledPrograms.length;i++){
            if(this.enrolledPrograms[i].programCode === program.programCode){
                this.selectedProgram = this.enrolledPrograms[i]
            }
        }
      },
      async populateStreamStructure (data, replace) {
        let stream = await this.loadStreamWithStructure({programCode: data.programCode, userId: this.uuid})
        let structure = stream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (children.length >2) {
                childStructure = structure
            }
            if (childStructure) {
              let cStructure = JSON.parse(childStructure)
              data.courses = _.sortBy(cStructure, 'order')


        let summaries = await this.loadStreamWithStructureSummary({programCode: data.programCode, userId: this.uuid})
        let performance = undefined
        let performanceCount=0
        data.inprogrerssCourses = 0
        for (let i = 0; i < summaries.length; i++) {
            let competencySummary =  summaries[i]
            data.childrenCount += competencySummary.childrenCount
            data.childrenCompleteCount += competencySummary.childrenCompleteCount
            data.totalCourses = data.courses.length
            if(competencySummary.status==2){
              data.completedCourses+=1
            }
            if(competencySummary.status==1){
              data.inprogressCourses = data.inprogressCourses+1
            }

            if(competencySummary.performance) {
                performanceCount++
                if(performance == undefined){
                    performance = competencySummary.performance
                }else{
                    performance += competencySummary.performance
                }
            }
        }
        if(performance !=undefined) {
          data.isScoreNotAvailable = false
          data.score =(performance / performanceCount).toFixed(2)
          data.performance=performance
        }
        let foundData = false
        if(this.enrolledPrograms.length>0){
            for (var i = 0; i < this.enrolledPrograms.length; i++) {
              if(this.enrolledPrograms[i].programCode ===data.programCode){
                this.enrolledPrograms[i] = data
                foundData = true
                break
              }
            }
        }
        if(!foundData){
          this.enrolledPrograms.push(data)
        }
        let catalogAndCourses = this.getTotalCourseCatalogs(data.courses)
        data.totalCourses = catalogAndCourses.length
        data.notStartedCourses = (data.totalCourses - (data.inprogressCourses+data.completedCourses))
        if(this.selectedProgram.programCode===data.programCode){
            this.selectedProgram = {}
            this.selectedProgram = data
        }

/*
              let courses = this.getCoursesFromStructure(data.courses)
              _.forEach(courses, async (course, index) => {
                let courseId = course.originUuid
                let mcSummary = await this.loadMicroCompetencyProgressForSelectedUser({entityId: courseId, userId: this.uuid})
                data.childrenCount += mcSummary.childrenCount
                data.childrenCompleteCount += mcSummary.childrenCompleteCount
                if (index === (courses.length - 1)) {
                  if(!replace){
                    this.enrolledPrograms.push(data)
                  }
                }
              })
*/
            }
          }
        }
      },
      getCoursesFromFolder (folder) {
        let courses = []
        if(!folder.structure){
            return courses
        }
        let structure = JSON.parse(folder.structure)
        if (structure) {
          let recursionEntities = _.sortBy(structure, 'order')
          recursionEntities.forEach((item, i) => {
            if (item.entityType === 'deliverycontext' || item.entityType == 'catalog' || item.entityType === 'catalog') {
              courses.push(item)
            }
          })
        }
        return courses
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },

      getCoursesFromStructure(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getCoursesFromStructure(recursionEntities)
                 courses.push(...response)
               }
             }
           } else if (item.entityType === 'deliverycontext') {
             courses.push(item)
           }

        })

        return courses
      },
      aggregateProgressSummary (progressSummary) {
/*
        if ((progressSummary.status === 1) || (progressSummary.status === 2)) {
          this.selectedProgram.progressSummaryCount += 1
          this.selectedProgram.isScoreNotAvailable = false
          this.selectedProgram.performance += progressSummary.performance
        }
        setTimeout(() => {
          this.selectedProgram.score = (this.selectedProgram.performance / this.selectedProgram.progressSummaryCount).toFixed(2)
        }, 1000)
*/
      },
      async loadLearnDashboard () {
        this.advisee = await this.loadAdviseeDetail(this.uuid)
        let tagsObj = await this.loadPersonTags(this.uuid)
        for (const [key, value] of Object.entries(tagsObj)) {
          value.forEach((tag, index) => {
            this.adviseeTags.push(tag.name)
          })
        }
        this.calendarEvents = await this.loadFutureCalendarEventsForParticipant(this.uuid)
        this.isDataLoaded = true
      },
      openAcademicProgressModal (doNotReset) {
        if (!doNotReset) {
          this.selectedProgram = null
          this.modalHeaderLabel = this.advisee.userName + '\'s Academic Progress for All Programs'
        }
        this.$refs.academicProgressModal.show()
      },
      showSelectedProgramProgress (data) {
        this.selectedProgram = data
        this.modalHeaderLabel = this.advisee.userName + '\'s Academic Progress for ' + data.programTitle
        this.$nextTick(() => {
          this.$refs.academicProgressModal.show()
        })
      },
      closeAcademicProgressModal () {
        this.$refs.academicProgressModal.hide()
      },
      statusClass (data) {
        if (data.score && !data.isScoreNotAvailable) {
          if (data.score >= 90) {
            return 'gradeA'
          } else if (data.score >= 80 && data.score < 90) {
            return 'gradeB'
          } else if (data.score >= 65 && data.score < 80) {
            return 'gradeC'
          } else if (data.score >= 40 && data.score < 65) {
            return 'gradeD'
          } else if (data.score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      showBarTitle (count, status) {
        if (count > 1) {
          return count + ' courses are ' + status
        } else {
          return count + ' course is ' + status
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      millisToDate (millis) {
        if(millis){
          return 'on ' + DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
        }else{
            return ''
        }

      },
      unenrollUserFromProgram (){
          this.$refs.learnerUnenrollModal.hide()
          this.unenrollFromProgram({userId:this.uuid, programCode:this.selectedProgram.programCode} )
          setTimeout(() => {
            window.location.reload()
          }, 2000)
      },
      rePrecessProgramEnroolemtForUser (){
          this.$refs.reprocessModal.hide()
          this.reProcessProgramEnrollment({userId:this.uuid, programCode:this.selectedProgram.programCode} )
/*
          setTimeout(() => {
            window.location.reload()
          }, 2000)
*/
      },

      manualRelease () {
          this.releaseCourse({uuid:this.selectedCourseForRelease.uuid, status:true}).then(prg => {
            this.releaseModalHeaderLabel = ''
            this.selectedCourseForReleaseTitle = ''
            this.$refs.learnerCourseReleaseModal.hide()
            this.selectedCourseForRelease = null

            this.resetData(this.selectedProgram)
            this.populateStreamStructure(this.selectedProgram, true)
            this.releaseLogicDetail = ''
            this.releaseStatus = true
            this.releaseStatusUpdatedBy = 'System'
            this.releaseStatusUpdatedTime =undefined

            // update when course is released.
            this.openAcademicProgressModal(true)
          })
      },
      manualLock () {
          this.releaseCourse({uuid:this.selectedCourseForRelease.uuid, status:false}).then(prg => {
            this.releaseModalHeaderLabel = ''
            this.selectedCourseForReleaseTitle = ''
            this.$refs.learnerCourseReleaseModal.hide()
            this.selectedCourseForRelease = null

            this.resetData(this.selectedProgram)
            this.populateStreamStructure(this.selectedProgram, true)
            this.releaseLogicDetail = ''
            this.releaseStatus = true
            this.releaseStatusUpdatedBy = 'System'
            this.releaseStatusUpdatedTime =undefined

            // update when course is released.
            this.openAcademicProgressModal(true)
          })
      },

      manualWaive () {
          this.waiveCourse({uuid:this.selectedCourseForWaive.uuid, details:this.waiveLogicDetail, score:this.waiveScore,status:!this.waiveStatus}).then(prg => {
            this.waiveModalHeaderLabel = ''
            this.selectedCourseForWaiveTitle = ''
            this.$refs.learnerCourseWaiveModal.hide()
            this.selectedCourseForWaive = null

            this.resetData(this.selectedProgram)
            this.populateStreamStructure(this.selectedProgram, true)
            this.waiveLogicDetail = ''
            this.waiveScore = ''
            this.waiveStatus = false
            this.waiveStatusUpdatedBy = 'System'
            this.waiveStatusUpdatedTime =undefined

            // update when course is released.
            this.openAcademicProgressModal(true)
          })

      },
      manualOverride () {
          if(!this.overrideScore || this.overrideScore>100 || this.overrideScore<1){
              alert('Edited Overall Score must be between 1 and 100')
              return
          }
          this.overrideCourseScore({uuid:this.selectedCourseForOverride.uuid, score:this.overrideScore}).then(prg => {
            this.selectedCourseForOverrideTitle = ''
            this.$refs.learnerCourseOverrideModal.hide()
            this.selectedCourseForOverride = null
            this.selectedCourseSummaryForOverride = null,
            this.overrideScore = ''
            this.overrideStatusUpdatedBy = 'System'
            this.overrideStatusUpdatedTime =undefined

            this.resetData(this.selectedProgram)
            this.populateStreamStructure(this.selectedProgram, true)
            this.openAcademicProgressModal(true)
          })

      },
        manualUnwaive () {
          this.waiveCourse({uuid:this.selectedCourseForWaive.uuid, details:this.waiveLogicDetail, score:this.waiveScore,status:!this.waiveStatus}).then(prg => {

            this.waiveModalHeaderLabel = ''
            this.selectedCourseForWaiveTitle = ''
            this.$refs.learnerCourseWaiveModal.hide()
            this.selectedCourseForWaive = null

            this.resetData(this.selectedProgram)
            this.populateStreamStructure(this.selectedProgram, true)
            this.waiveLogicDetail = ''
            this.waiveScore = ''
            this.waiveStatus = false
            this.waiveStatusUpdatedBy = 'System'
            this.waiveStatusUpdatedTime =undefined

            // update when course is released.
            this.openAcademicProgressModal(true)
          })


      },
      openWaiveDetailModal (course, unlocked) {
        this.waiveModalHeaderLabel = course.waiveStatus?'Course is Waived':'Course is Not Waived'
        this.selectedCourseForWaiveTitle = course.title
        this.$refs.learnerCourseWaiveModal.show()
        this.selectedCourseForWaive = course
        this.waiveLogicDetail = course.waiveLogicDetail
        this.waiveStatusUpdatedBy = course.waiveStatusUpdatedBy
        this.waiveStatusUpdatedTime = course.waiveStatusUpdatedTime
        this.waiveStatus = unlocked
      },
      openOverrideDetailModal (course, tempsummary) {
        this.selectedCourseForOverrideTitle = course.title
        this.selectedCourseForOverride = course
        this.selectedCourseSummaryForOverride = tempsummary
        this.overrideScore = tempsummary.overriddenTime?tempsummary.performance:''
        this.overrideStatusUpdatedBy = course.overrideStatusUpdatedBy
        this.overrideStatusUpdatedTime = course.overrideStatusUpdatedTime
        this.$refs.learnerCourseOverrideModal.show()
      },
      closeLearnerCourseOverrideModal () {
        this.selectedCourseForOverrideTitle = ''
        this.$refs.learnerCourseOverrideModal.hide()
        this.selectedCourseForOverride = null
        this.selectedCourseSummaryForOverride = null
        this.overrideScore = ''
        this.overrideStatusUpdatedBy = 'System'
        this.overrideStatusUpdatedTime =undefined
        this.openAcademicProgressModal(true)
      },
      closeLearnerCourseWaiveModal(){
        this.selectedCourseForWaiveTitle = ''
        this.$refs.learnerCourseWaiveModal.hide()
        this.selectedCourseForWaive = null
        this.waiveLogicDetail = ''
        this.waiveScore = ''
        this.waiveStatus = false
        this.waiveStatusUpdatedBy = 'System'
        this.waiveStatusUpdatedTime =undefined

        this.openAcademicProgressModal(true)
      },
      openLearnerUnenrollModal (program, advisee) {
        this.$refs.learnerUnenrollModal.show()
      },
      closeLearnerUnenrollModal () {
        this.$refs.learnerUnenrollModal.hide()
      },
      openReprocessModal (program, advisee) {
        this.$refs.reprocessModal.show()
      },
      closeReprocessModal () {
        this.$refs.reprocessModal.hide()
      },

      openReleaseDetailModal (course, unlocked) {
        this.releaseModalHeaderLabel = course.releaseStatus?'Course is Unlocked':'Course is Locked'
        this.selectedCourseForReleaseTitle = course.title
        this.$refs.learnerCourseReleaseModal.show()
        this.selectedCourseForRelease = course
        this.releaseLogicDetail = course.releaseLogicDetail
        this.releaseStatusUpdatedBy = course.releaseStatusUpdatedBy
        this.releaseStatusUpdatedTime = course.releaseStatusUpdatedTime
        this.releaseStatus = unlocked
      },
      closeLearnerCourseReleaseModal () {
        this.releaseModalHeaderLabel = ''
        this.selectedCourseForReleaseTitle = ''
        this.$refs.learnerCourseReleaseModal.hide()
        this.selectedCourseForRelease = null
        this.releaseLogicDetail = ''
        this.releaseStatus = true
        this.releaseStatusUpdatedBy = 'System'
        this.releaseStatusUpdatedTime =undefined

        this.openAcademicProgressModal(true)
      },
      openLearnerCourseReportModal (course) {
        this.reportModalHeaderLabel = this.advisee.userName + '\'s View of Course Report'
        this.$refs.learnerCourseReportModal.show()
        this.selectedCourseForReporting = course
      },
      isCustomAdvisor (){
        return this.userObj.customAdvisor
      },
      customAdvisorWaive () {
        return this.customAdvisorfeature('Allow Waive Course')
      },
      customAdvisorUnlock () {
        return this.customAdvisorfeature('Allow Unlock Course')
      },
      customAdvisorAllowUnenroll () {
        return this.customAdvisorfeature('Allow Unenroll')
      },
      customAdvisorLearnerHome () {
        return this.customAdvisorfeature('Show Learner Home')
      },
      customAdvisorfeature (flagValue) {
        if(!this.isCustomAdvisor()){
            return true
        }
        let customAdvisorFeature = this.enabledFeatures['Custom Advisor']
        if (customAdvisorFeature) {
          let flags = customAdvisorFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === flagValue) {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      closeLearnerCourseReportModal () {
        this.reportModalHeaderLabel = ''
        this.selectedCourseForReporting = null
        this.$refs.learnerCourseReportModal.hide()
        this.openAcademicProgressModal(true)
      },
      navigateToClassCourseReport () {
        let uuid = this.selectedCourseForReporting.originUuid
        return this.$router.push({name: 'classReport', params: {uuid: uuid, competencyId: uuid, isShowLearnosityReport: false, isAdvisorViewingReport: true}})
      },
      navigateToAdviseeProfile () {
        return this.$router.push({name: 'learnerProfilePage', params: {uuid: this.uuid}})
      }
    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures,
        'userObj': state => state.user.userObj
      }),
      advisorDashboardFeature () {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
      },
      isProgramProgressEnabled () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isReporcessEnrollmentEnabled () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'reprocessEnrollment') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },

      isShowProgramName () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramNameWithLabel') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      majorLabel () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramNameWithLabel' && flags[i].label.length > 0) {
              return flags[i].label
            }
          }
        }
        return 'Program'
      },
      isShowCareerInterest () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCareerInterestWithLabel') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      careerLabel () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCareerInterestWithLabel' && flags[i].label.length > 0) {
              return flags[i].label
            }
          }
        }
        return 'Career Interest'
      },
      redirectStreamToProgressView () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'redirectStreamToProgressView') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isCalendarEnabled () {
        let calendar = this.enabledFeatures[PACKAGE.FEATURE_IDS.CALENDAR]
        if (calendar && calendar.enabled) {
          return true
        }
        return false
      },
      isLearnerProfileEnabled () {
        let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'advisorCanAccessLearnerProfile')
          })
          return found ? found.enabled : false
        }
        return false
      }
    }
  }
</script>

<style>
  .popup_head_txt {
    color: #323232;
    font-weight: 800;
    font-size: 1.4rem;
    float: left;
    width: 98%;
  }

  .bg-academic-progress-popup-header {
    background: #eaf8ff !important;
  }

  .header-text {
    color: #fff;
    font-weight: 500;
    font-size: x-large;
    padding-top: 10px;
  }
  .enrolled_program_row {
    transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdvisorLearnerHomePage.vue